module.exports = __webpack_public_path__ + "media/images/home/orange_arrow-cc93aeb6485b9554fa66c6491f8396ea.png";